<template>
<div class="chapter">
<div class="inner_page">
<p class="P_OtherAnthologiesTitle"><span>Other Anthologies Edited by:</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">Patricia Bray &amp; Joshua Palmatier</span></span></p>
<p class="P_AnthologyTitles"><span>After Hours: Tales from the Ur-bar</span></p>
<p class="P_AnthologyTitles"><span>The Modern Fae’s Guide to Surviving Humanity</span></p>
<p class="P_AnthologyTitles"><span>Temporally Out of Order  *  Alien Artifacts  *  Were-</span></p>
<p class="P_AnthologyTitles"><span>All Hail Our Robot Conquerors!</span></p>
<p class="P_AnthologyTitles"><span>Second Round: A Return to the Ur-bar</span></p>
<p class="P_AnthologyTitles"><span>The Modern Deity’s Guide to Surviving Humanity</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-family: 'Times New Roman',serif; font-size: 0.71em;">Solar Flare</span></span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">S.C. Butler &amp; Joshua Palmatier</span></span></p>
<p class="P_AnthologyTitles"><span>Submerged  *  Guilds &amp; Glaives  *  Apocalyptic</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-family: 'Times New Roman',serif; font-size: 0.71em;">When Worlds Collide  *  Brave New Worlds  *  Dragonesque</span></span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">Laura Anne Gilman &amp; Kat Richardson</span></span></p>
<p class="P_AnthologyTitles"><span>The Death of All Things</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">Troy Carrol Bucher &amp; Joshua Palmatier</span></span></p>
<p class="P_AnthologyTitles"><span>The Razor’s Edge</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">Patricia Bray &amp; S.C. Butler</span></span></p>
<p class="P_AnthologyTitles"><span>Portals</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">David B. Coe &amp; Joshua Palmatier</span></span></p>
<p class="P_AnthologyTitles"><span>Temporally Deactivated  *  Galactic Stew</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-family: 'Times New Roman',serif; font-size: 0.71em;">Derelict</span></span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">Steven H Silver &amp; Joshua Palmatier</span></span></p>
<p class="P_AnthologyTitles"><span>Alternate Peace</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">Crystal Sarakas &amp; Joshua Palmatier</span></span></p>
<p class="P_AnthologyTitles"><span>My Battery Is Low and It Is Getting Dark</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">David B. Coe &amp; John Zakour</span></span></p>
<p class="P_AnthologyTitles"><span>Noir</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">Crystal Sarakas &amp; Rhondi Salsitz</span></span></p>
<p class="P_AnthologyTitles"><span>Shattering the Glass Slipper</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">David B. Coe &amp; Edmund R. Schubert</span></span></p>
<p class="P_AnthologyTitles"><span>Artifice &amp; Craft</span></p>
<p class="P_OtherAnthologiesAuthors"><span><span style=" font-weight: bold; font-family: 'Palatino Linotype',serif; font-size: 0.86em;">Steven Kotowych &amp; Tony Pi</span></span></p>
<p class="P_AnthologyTitles"><span>Game On!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?f9cc3690